import { Outlet } from 'react-router-dom';
import { MobileTabBar } from './MobileTabBar';

export function MobileTabShell() {
  return (
    <div className="min-h-screen bg-[#FBEAE0]">
      <div className="pb-28"><Outlet /></div>
      <MobileTabBar />
    </div>
  );
}
